import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { StorageService } from '../../services/storage.service';
import { MaintainService } from '../../services/maintain.service';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { GS1HeaderService, HeaderAlert } from '@gs1france/gs1-components-library';
import { TokenGS1Service } from '../../services/tokenGS1.service';
import { MaintenanceMessageService } from '../../services/maintenanceMessage.service';

@Component({
    selector: 'header-comp',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() pageTitle : string;
    isAuthorizedSubscription: Subscription;
    isLoggedIn: boolean = false;
    avatarDivOver: boolean = false;
    logoffDivOver: boolean = false;
    isDropdownSelectAccountVisible: boolean = false;
    isFederation = false;
    multiple: boolean = false;

    session: any;
    nomEntreprise: string = "";
    nomComplet: string;
    emailAdherent: string = "";

    listeLangues: string[] = ["fr", "en"];
    langueChosen: string = "";

    informationsMessageMaintain: string;
    displayBanner: boolean = false;
    actifBanner: boolean = false;
    subs: Subscription[] = [];
    companyDisplay: any;
    hasCustomerNumber : boolean=false;
    disablePackSetting : boolean;
   tokenAdmin ='';

    constructor(private router: Router,private infosMessageService: MaintainService, private oauthService: OAuthService, private storageService: StorageService, private translate: TranslateService, private _header: GS1HeaderService,private _tokenGS1Service: TokenGS1Service, private maintenanceMessageService: MaintenanceMessageService) {
        this.isLoggedIn = this.oauthService.hasValidAccessToken();
        this.isAuthorizedSubscription = this.oauthService.events.subscribe(event => {
            if (event instanceof OAuthSuccessEvent && (event.type === 'token_received' || event.type === 'token_refreshed')) {
                if (this.oauthService.hasValidAccessToken()) {
                    this.isLoggedIn = true;
                }
            }
        });
    }
        
    async ngOnInit() {
        this.session = this.storageService.getSession();
        this.multiple = this.storageService.getMultiple();
        const [tokenAdmin] = await Promise.all([this._tokenGS1Service.getTokenGS1Admin()]);
        this.tokenAdmin=tokenAdmin;
        localStorage.setItem("tokenAdmin", tokenAdmin);
        this.getMaintenanceMessage();
        this.isFederation = await this.storageService.isUserFederation();
   
        if (this.session) {
            this.nomEntreprise = this.session["company_name"];
            this.emailAdherent = this.session["email"];
            this.nomComplet = this.storageService.getNomComplet();           
        }
        this.subs.push(this.storageService.nomComplet.subscribe(value => this.nomComplet = value));
        this.subs.push(this.storageService.session.subscribe(value => {
            this.session = value;
            this.nomEntreprise = this.session["company_name"];
            this.emailAdherent = this.session["email"];
            this.nomComplet = this.storageService.getNomComplet();
        }));
        this.subs.push(this.storageService.multiple.subscribe(value => this.multiple = value))
        if (!this.browserIsCompatible()) {
            setTimeout(() => {
                this._header.addAlert(new HeaderAlert('warning', 'Veuillez changer ou mettre à jour votre navigateur internet pour bénéficier d\'une expérience de visionnage optimale.'))
            }, 1000)
        }
        try {
            // this.informationsMessageMaintain = await this.infosMessageService.getMaintainInfos();
            this.companyDisplay = await this.storageService.getCompanyDisplayedSections();
            const disablePack = (await this.storageService.getSettings()).values.DisablePackPartenaire;
            if (disablePack && disablePack.defaultValue) {
                this.disablePackSetting = disablePack.defaultValue.toLowerCase() == 'true';
            }
            this.hasCustomerNumber = this.companyDisplay.hasCustomerNumber;
            // if (this.informationsMessageMaintain !== null) {
            //     this.displayBanner = true;
            // }
        }
        catch (e) {
            return;
        }

    }

    async getMaintenanceMessage() {
       const message =  await this.maintenanceMessageService.getMaintenanceMessage();
        if(message)
       {
        this._header.addAlert(new HeaderAlert(message.theme, message.message));
       }
    }
    
    ngOnDestroy(): void {
        this.isAuthorizedSubscription.unsubscribe();
        this.subs.forEach(sub => sub.unsubscribe());
    }


    logout() {
        this.storageService.clearStorage();
        this.oauthService.logOut();
    }

    enterAvatarDiv() {
        this.avatarDivOver = true;
    }
    leaveAvatarDiv() {
        setTimeout(() => { this.avatarDivOver = false; }, 200);
    }
    enterUserInfosDiv() {
        this.logoffDivOver = true;
    }
    leaveUserInfosDiv() {
        setTimeout(() => { this.logoffDivOver = false; }, 200);
    }

    changeAccount() {
        if (this.isDropdownSelectAccountVisible) {
            this.isDropdownSelectAccountVisible = false;
        } else {
            this.isDropdownSelectAccountVisible = true;
        }
        
    }

    changeCompany() {
        this.storageService.removeCompanyData();
        try {
            this.oauthService.customQueryParams = {
              'companies': true,
              'prompt':'login'
            }
            this.oauthService.resetImplicitFlow();
            this.oauthService.initImplicitFlow();
          } catch {
           }
    }

    showGreyIcon() {
        var isHub = window.location.pathname == "/hub";
        if (isHub)
            return true;
        else
            return false;
    }

    public onChange(event: { target: { value: string; }; }): void {
        this.langueChosen = event.target.value;
        this.translate.use(this.langueChosen);
    }

    browserIsCompatible() {
        if(typeof ResizeObserver === 'undefined') {
            return false
        };
        return true
    }
}